<template>
  <div
    class="dropdown"
    :class="{'is-active': isActive}"
    @mouseenter="isActive = true"
    @mouseleave="isActive = false"
  >
    <div
      class="dropdown-trigger"
      aria-haspopup="true"
    >
      <slot name="trigger"/>
    </div>
    <div
      class="dropdown-menu"
      :aria-hidden="!isActive"
    >
      <div
        class="dropdown-content"
        :role="ariaRole"
      >
        <slot/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {provide, ref} from 'vue';
  import {DROPDOWN} from '@/components/ui/dropdown';

  /** Bulma dropdown that opens on hover and closes when an item is chosen. */
  withDefaults(defineProps<{
    ariaRole?: string;
  }>(), {
    ariaRole: undefined,
  });

  const isActive = ref(false);

  provide(DROPDOWN, {
    close: () => {
      isActive.value = false;
    },
  });
</script>
